module.exports = __webpack_public_path__ + "assets/img/thumb-FormPiper-Landing-Page-+-Website.9ab86825.jpg";